import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import advanced from 'dayjs/plugin/advancedFormat';
import tz from 'dayjs/plugin/timezone';
dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(tz);
dayjs.extend(advanced);

@Pipe({
    name: 'lenientDate',
    standalone: true
})
export class LenientDatePipe implements PipeTransform {
    transform(
        value: Date | string | number,
        format = 'mediumDate',
        isUtc = false,
        timezone = '',
        locale = 'en-US',
        treatAsUtc = false
    ): string {
        if (!value || (typeof value === 'string' && value.startsWith('1900-'))) {
            return '';
        }

        if (treatAsUtc) {
            return dayjs(value).utc(true).format('L LTS');
        }

        if (timezone === 'default') {
            timezone = ` (${dayjs(value).format('z')})`;
        }

        /* formatDate() assumes local time, we need to append a timezone string if this is a UTC value;
         * we do NOT want to do this if there's no time component. */
        if (
            typeof value === 'string' &&
            isUtc &&
            !value.includes('+') &&
            !format.endsWith('Date') &&
            !value.includes('T00:00:00') &&
            !value.endsWith('Z')
        ) {
            return formatDate(value + '+0000', format, locale, undefined);
        }

        return `${formatDate(value, format, locale)}${timezone}`;
    }
}
